<template>
    <br>
    <div id="service-multiple" class="one-service-area ptb-100">
        <div class="container">
            <div class="one-section-title">
                <span class="sub-title">{{ subTitle }}</span>
                <h2>{{ heading }}</h2>
            </div>

            <!-- Tabs centradas -->
            <nav class="tabs">
                <div class="tabs__header">
                    <a 
                        class="tabs__header-item" 
                        v-for="tab in tabs" 
                        v-on:click="selectTab(tab.id)" 
                        v-bind:class="{ 'active': activeTab == tab.id }"
                        :key="tab.id"
                    >
                        <div class="service-item">
                            <i :class="tab.icon"></i>
                            <span>{{ tab.name }}</span>
                        </div>
                    </a>
                </div>
            </nav>

            <!-- Contenedor de contenido centrado -->
            <div class="tabs__container tabs__container--center">
                <div 
                    class="tabs__list"
                    ref="tabsList"
                >
                    <div 
                        class="tabs__list-tab"
                        v-for="tab in tabs"
                        v-bind:class="{ 'active': activeTab == tab.id }"
                        :key="tab.id"
                    >
                        <div class="service-advisor">
                            <div class="row align-items-center">
                                <div class="col-lg-6">
                                    <div class="advisor-img">
                                        <img :src="tab.image" alt="Tintas">
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="advisor-content">
                                        <h2>{{ tab.title }}</h2>
                                        <p>{{ tab.shortDesc }}</p>
                                        <ul>
                                            <li
                                                v-for="list in tab.lists"
                                                :key="list.id"
                                            >
                                                <i :class="list.icon"></i>
                                                {{ list.text }}
                                            </li>
                                        </ul>
                                        <div class="advisor-link">
                                            <a href="tel:+34 623 61 51 28">
                                                COMPRAR / PEDIR
                                            </a>
                                            <i class="bx bx-right-arrow-alt"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OurCoreService',
    props: ['subTitle', 'heading'],
    data () {
        return {
            activeTab: 1,
            offsetRight: 0,
            
            tabs: [
                {
                    id: 1,
                    icon: 'bx bxs-lock',
                    name: 'Privacidad',
                    title: 'Política de privacidad y tratamiento de datos',
                    shortDesc:
                        'Protegemos la información de nuestros clientes. Tratamos tus datos únicamente para dar soporte técnico, gestionar intervenciones y responder solicitudes comerciales.',
                    image: require('@/assets/img/resources/p4.png'),
                    lists: [
                        {
                            id: 1,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Recogemos datos como nombre, teléfono, email, empresa y descripción del problema técnico.'
                        },
                        {
                            id: 2,
                            icon: 'bx bxs-chevrons-right',
                            text: 'No vendemos ni cedemos tu información a terceros con fines comerciales.'
                        },
                        {
                            id: 3,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Utilizamos estos datos para programar intervención, enviar presupuestos y hacer seguimiento de la máquina.'
                        },
                        {
                            id: 4,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Podés pedir actualización o eliminación de tus datos escribiendo a serviciotecnico@plotix.es.'
                        }
                    ]
                },

                // 5. Garantía y responsabilidad
                {
                    id: 2,
                    icon: 'bx bx-shield-quarter',
                    name: 'Garantía',
                    title: 'Garantía de intervención y limitaciones de responsabilidad',
                    shortDesc:
                        'Actuamos con transparencia: te explicamos qué cubre nuestro trabajo y qué no, para evitar malentendidos en el entorno productivo.',
                    image: require('@/assets/img/resources/p5.png'),
                    lists: [
                        {
                            id: 1,
                            icon: 'bx bxs-chevrons-right',
                            text: 'La garantía cubre exclusivamente la reparación o el ajuste realizado por Plotix sobre esa pieza o zona intervenida.'
                        },
                        {
                            id: 2,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Manipulaciones posteriores por parte de terceros pueden anular esa garantía.'
                        },
                        {
                            id: 3,
                            icon: 'bx bxs-chevrons-right',
                            text: 'No asumimos responsabilidad por pérdidas de producción o lucro cesante derivadas de una avería.'
                        },
                        {
                            id: 4,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Priorizamos urgencias en equipos en producción activa para minimizar el tiempo de parada.'
                        }
                    ]
                },

                // 6. Atención y soporte
                {
                    id: 3,
                    icon: 'bx bx-headphone',
                    name: 'Soporte',
                    title: 'Atención al cliente y soporte técnico',
                    shortDesc:
                        'Te ayudamos tanto en remoto como en sitio. Sabemos que cuando la impresora se detiene, el trabajo se detiene.',
                    image: require('@/assets/img/resources/p6.png'),
                    lists: [
                        {
                            id: 1,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Horario de recepción: Atención técnica 24/7: disponible todos los días del año, sin interrupciones.'
                        },
                        {
                            id: 2,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Ofrecemos asistencia telefónica y soporte remoto mediante acceso en línea.'
                        },
                        {
                            id: 3,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Podemos desplazarnos físicamente para intervención en máquina cuando es necesario.'
                        },
                        {
                            id: 4,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Contacto directo: +34 623 61 51 28 · serviciotecnico@plotix.es'
                        }
                    ]
                },
            ]
        }
    },
    methods: {
        selectTab (id) {
            const tabsList = this.$refs.tabsList
            this.activeTab = id
            this.offsetRight = tabsList.clientWidth * (id - 1)
            tabsList.style.right = this.offsetRight + 'px'
        }
    }, 
    mounted () {
        const tabsList = this.$refs.tabsList
        tabsList.style.right = this.offsetRight + 'px'
    },
    computed: {
        products(){
            return this.$store.state.products.all.filter(item => {
                return item.productsType === 'left-sidebar'
            })
        }
    }
}
</script>

<style scoped>
/* ===============================
   Bloque de pestañas centradas
   =============================== */

/* Contenedor de tabs centrado y con columnas iguales */
.tabs__header {
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 280px)); /* botones iguales */
  gap: 1rem;
  justify-content: center;    /* 🔹 centra el grupo de botones */
  align-items: center;
  margin: 0 auto 2rem;        /* centrado + espacio inferior */
  width: 100%;
}

/* Cada enlace ocupa toda su celda */
.tabs__header-item {
  display: block;
  text-decoration: none;
  width: 100%;
}

/* Botón */
.service-item {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 16px 18px;
  border-radius: 10px;
  transition: all 0.3s ease;
}

/* Estado activo */
.tabs__header-item.active .service-item {
  background: var(--main-color, #d35400);
  color: #fff;
}

/* Estado inactivo */
.tabs__header-item:not(.active) .service-item {
  background: #f4f4f4;
  color: #333;
}

/* Hover */
.tabs__header-item:hover .service-item {
  opacity: 0.9;
}

/* Responsive: en móviles apila verticalmente */
@media (max-width: 600px) {
  .tabs__header {
    grid-template-columns: 1fr;
    max-width: 360px;
    justify-content: center;
  }
}

/* ===============================
   Contenido del bloque general
   =============================== */

.tabs__container--center {
  max-width: 1100px;
  margin: 0 auto;
}

.one-section-title {
  text-align: center;
}

.one-section-title h2 {
  margin-bottom: 2rem;
}

/* Estilo del enlace dentro de cada pestaña */
.advisor-link a {
  color: var(--main-color, #d35400);
  font-weight: bold;
  text-decoration: none;
}
/* ====== Fix centrado y ancho ESTABLE SOLO en tablet (768–1199px) ====== */
@media (min-width: 768px) and (max-width: 1199px) {
  /* Centra el contenedor de tabs dentro del .container */
  .tabs {
    display: flex;
    justify-content: center;
  }

  /* 2 columnas fijas y centradas, sin permitir encogimiento */
  .tabs__header {
    display: grid;
    grid-template-columns: repeat(2, 280px);   /* ancho fijo por botón */
    gap: 1rem;
    justify-content: center;                   /* centra el grupo */
    margin-left: auto;
    margin-right: auto;
    max-width: calc(560px + 1rem);             /* 2×280 + gap */
  }

  /* Evita que el contenido se “aplane” en puntos intermedios */
  .tabs__header-item,
  .tabs__header-item .service-item {
    min-width: 280px;      /* coincide con la columna */
    flex: 0 0 auto;        /* no encoge en ningún caso */
  }
}


</style>
